(function() {
  var extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  exports.Field = (function(superClass) {
    extend(Field, superClass);

    function Field(data) {
      var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7;
      if (data == null) {
        data = {};
      }
      Field.__super__.constructor.call(this);
      this.name = ko.observable((ref = data.name) != null ? ref : "");
      this.farm = ko.observable((ref1 = data.farms_id) != null ? ref1 : null);
      this.id = (ref2 = data.id) != null ? ref2 : null;
      this.rawAcres = ko.observable(0);
      this.acreage = ko.computed((function(_this) {
        return function() {
          return _this.rawAcres().toFixed(1);
        };
      })(this));
      this.tile_density = ko.observable((ref3 = data.tile_density) != null ? ref3 : null);
      this.tile_spacing = ko.observable((ref4 = data.tile_spacing) != null ? ref4 : null);
      this.previous_crop = (ref5 = data.previous_crop) != null ? ref5 : null;
      this.soil_productivity = (ref6 = data.soil_productivity) != null ? ref6 : null;
      this.geometry = (ref7 = data.geometry) != null ? ref7 : null;
    }

    Field.prototype.displayGeometry = function() {
      if ((this.geometry != null) && this.geometry instanceof L.FeatureGroup) {
        return App.map.addLayer(this.geometry);
      }
    };

    Field.prototype.hideGeometry = function() {
      if ((this.geometry != null) && this.geometry instanceof L.FeatureGroup) {
        return App.map.removeLayer(this.geometry);
      }
    };

    Field.prototype.destroy = function() {
      this.hideGeometry();
      if ((this.irrigationGeometry != null) && this.irrigationGeometry instanceof L.FeatureGroup) {
        return App.map.removeLayer(this.irrigationGeometry);
      }
    };

    Field.prototype.save = function(cb) {
      var fieldPost, geom, wkt;
      wkt = new Wkt.Wkt();
      geom = wkt.fromObject(this.geometry).write();
      fieldPost = {
        farms_id: this.farm(),
        id: this.id,
        geom: geom,
        name: this.name(),
        tile_density: this.tile_density(),
        tile_spacing: this.tile_spacing(),
        irrigation_type: this.irrigation_type,
        previous_crop: this.previous_crop,
        soil_productivity: this.soil_productivity
      };
      return $.post("backend/grower/fields/define/create-field", ko.toJSON(fieldPost), cb);
    };

    return Field;

  })(KoModel);

}).call(this);
